import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'caseApplyRecordController';
export default {
    /**
     * 调账
     */
    accountAdjustment: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'accountAdjustment',
        type: requestType.Post
    },
};
